module.exports = __webpack_public_path__ + "static/media/savings-transaction.b0c26ff2.svg";